import { v4 as uuidv4 } from 'uuid'

export default class {
  _id
  _nombres
  _paterno
  _materno
  _email
  _rfc
  _isCurrenUser
  _orden
  _firmarEnOrden
  _firmado

  constructor() {
    this._id = uuidv4()
    this._nombres = ''
    this._paterno = ''
    this._materno = ''
    this._email = ''
    this._rfc = ''
    this._isCurrenUser = false
    this._orden = 0
    this._firmarEnOrden = false
    this._firmado = false
  }

  get nombreCompleto() {
    return `${this._nombres} ${this._paterno} ${this._materno}`
  }

  get id() {
    return this._id
  }

  get nombres() {
    return this._nombres
  }

  get paterno() {
    return this._paterno
  }

  get materno() {
    return this._materno
  }

  get email() {
    return this._email
  }

  get rfc() {
    return this._rfc
  }

  get isCurrentUser() {
    return this._isCurrenUser
  }

  get firmado() {
    return this._firmado
  }

  set id(value) {
    this._id = value
  }

  set nombres(value) {
    this._nombres = value
  }

  set email(value) {
    this._email = value
  }

  set rfc(value) {
    this._rfc = value
  }

  set paterno(value) {
    this._paterno = value
  }

  set materno(value) {
    this._materno = value
  }

  set isCurrentUser(value) {
    this._isCurrenUser = value
  }

  set orden(value) {
    this._orden = value
  }

  get orden() {
    return this._orden
  }

  get firmarEnOrden() {
    return this._firmarEnOrden
  }

  set firmarEnOrden(value) {
    this._firmarEnOrden = value
  }

  set firmado(value) {
    this._firmado = value
  }
}
